import log from "loglevel";
import { toast } from "react-toastify";

// Set the log level (could be dynamic based on environment)
log.setLevel(process.env.NODE_ENV === "development" ? "debug" : "warn");

const Logger = {
    trace: (message: string, ...args: unknown[]) => {
        log.trace(message, ...args);
    },
    debug: (message: string, ...args: unknown[]) => {
        log.debug(message, ...args);
    },
    info: (message: string, showAlert: boolean = false, ...args: unknown[]) => {
        log.info(message, ...args);
        if(showAlert) toast.info(message)
    },
    warn: (message: string, ...args: unknown[]) => {
        log.warn(message, ...args);
        toast.warn(message);
    },
    error: (message: string, ...args: unknown[]) => {
        log.error(message, ...args);
        toast.error(message);
    },
};

export default Logger;
